import { isNil } from 'lodash/fp';
import { type TextImageWebPageBlockDataFragment } from '../../../../../api/fragments/TextImageWebPageBlockData';
import { WebPageBlockBackground, WebPageBlockPosition } from '../../../../../api/types';
import renderMarkdown from '../../../../../utilities/renderMarkdown';
import usePublic from '../../../../../utilities/usePublic';
import useTranslatedString from '../../../../../utilities/useTranslatedString';
import {
    StyledTextImageDetailsContainer,
    StyledTextImageText,
    StyledTextImageTitle,
    StyledTextImageContainer,
    StyledTextImage,
    StyledTextImageDetail,
    colImageSpan,
    colDetailSpan,
    BlockButton,
    TextImageDetailsContainer,
    TextImageAssetContainer,
} from '../shared';

type TextImageBlockProps = {
    textImageBlock: TextImageWebPageBlockDataFragment;
};

const TextImageBlock = ({ textImageBlock }: TextImageBlockProps) => {
    const translated = useTranslatedString();

    const fallbackSrc = usePublic('empty.svg');
    const image = !isNil(textImageBlock.image) ? textImageBlock.image.url : fallbackSrc;

    const textTitle = translated(textImageBlock.title);

    const TextImageDetails = (
        <StyledTextImageDetailsContainer
            isBlackBackground={textImageBlock.backgroundType === WebPageBlockBackground.Black}
        >
            <StyledTextImageDetail>
                {textTitle && (
                    <StyledTextImageTitle itemProp="alternativeHeadline" level={3}>
                        {textTitle}
                    </StyledTextImageTitle>
                )}
                <StyledTextImageText>{renderMarkdown(translated(textImageBlock.description))}</StyledTextImageText>
                {textImageBlock.button && <BlockButton button={textImageBlock.button} />}
            </StyledTextImageDetail>
        </StyledTextImageDetailsContainer>
    );

    return (
        <StyledTextImageContainer isImagePositionLeft={textImageBlock.imagePosition === WebPageBlockPosition.Left}>
            <TextImageAssetContainer {...colImageSpan}>
                <StyledTextImage preview={false} src={image} />
            </TextImageAssetContainer>
            <TextImageDetailsContainer {...colDetailSpan}>{TextImageDetails}</TextImageDetailsContainer>
        </StyledTextImageContainer>
    );
};

export default TextImageBlock;
